import type {RoomsType} from '@/modules/common/models/rooms';
import type {Price} from '@/redux/v1/models';

import {config} from '@/config';

export const getDisplayPrice = (
  price: Price | null | undefined,
  rooms: RoomsType | undefined
): Price | null =>
  price
    ? {
        ...price,
        amount:
          config.global.pricePerPerson && rooms && rooms.length > 1
            ? price.amount / rooms.travellerCount
            : price.amount,
      }
    : null;
